var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2297_5966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49697 6.48835L6.21734 3.20872C5.94165 2.93303 5.49052 2.93303 5.21125 3.20872C4.93198 3.48799 4.9284 3.93912 5.20767 4.21839C5.20767 4.21839 5.20767 4.21839 5.21125 4.22197L8.49804 7.49443C8.77731 7.7737 8.78089 8.22483 8.50162 8.5041C8.50162 8.5041 8.50162 8.5041 8.49804 8.50768L5.21125 11.7801C4.93198 12.0594 4.9284 12.5105 5.20767 12.7898C5.48694 13.0691 5.93807 13.0727 6.21734 12.7898L9.49697 9.51019C10.3312 8.67238 10.3312 7.319 9.49697 6.48119V6.48835Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2297_5966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.12352,
    height: 10,
    fill: "white",
    transform: "translate(5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNext);
export default __webpack_public_path__ + "static/media/ico-next.b36aaa5ad4fadb47ff119c659b778c57.svg";
export { ForwardRef as ReactComponent };